<!-- 
Panel for displaying details of an exception log entry.
-->
<template>
  <v-card class="home">
    <our-busy-indicator :show="loading"/>
    <our-data-container>
      <our-data-field label="ID">{{ log.id }}</our-data-field>
      <our-data-field label="Date">{{ log.date | longDateTime }}</our-data-field>
      <our-data-field label="Level">
        <span :class="log.level | exceptionLogColour">{{ log.level }}</span>
      </our-data-field>
      <our-data-field label="User">{{ userInfo }}</our-data-field>
    </our-data-container>
    <v-divider />
    <our-data-container>
      <our-data-field label="Path">{{ log.requestPath }}</our-data-field>
      <our-data-field label="Method">{{ log.requestMethod }}</our-data-field>
      <our-data-field label="Content type">{{ log.requestContentType }}</our-data-field>
    </our-data-container>
    <v-divider />
    <our-data-container>
      <our-data-field label="Server">{{ log.server }}</our-data-field>
      <our-data-field label="Message">{{ log.message }}</our-data-field>
      <our-data-field label="Logger">{{ log.logger }}</our-data-field>
      <our-data-field label="Callsite">{{ log.callsite }}</our-data-field>
    </our-data-container>
    <v-divider v-if="log.exception" />
    <v-expansion-panel v-if="log.exception" v-model="expander" class="elevation-0">
      <v-expansion-panel-content>
        <div slot="header">
          <v-icon>error_outline</v-icon>
          <span class="ml-4 font-weight-medium subheading">Exception</span>
        </div>
        <v-card flat>
          <our-data-container>
            <our-data-field label-width="11">
              <code>{{ log.exception }}</code>
            </our-data-field>
          </our-data-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
</template>

<script>
import * as action from "@/store/exception-logs/action-types";
import filterMixins from "@/mixins/filter.mixins";

export default {
  mixins: [filterMixins],
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      expander: 0,
      showError: false,
      error: null
    };
  },
  computed: {
    state() {
      return this.$store.state.exceptionLogs.view;
    },
    loaded() {
      return this.state.loaded;
    },
    loading() {
      return this.state.loading;
    },
    log() {
      return this.state.data;
    },
    userInfo() {
      return this.log.userName + (this.log.userId ? `(${this.log.userId})` : "");
    }
  },
  watch: {
    id() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reload() {
      if ((!this.state.loaded && !this.state.loading) || this.id != this.state.exceptionId) {
        this.$store.dispatch(action.VIEW, this.id);
      }
    }
  }
};
</script>
